/* -------------------------- Design imports start -------------------------- */
import { Card, CardContent, Skeleton } from '@mui/material'
/* --------------------------- Design imports end --------------------------- */
/* ------------------------ Functional imports start ------------------------ */
import React, { type ReactElement } from "react";

import Page from '../layout/Page'
/* ------------------------- Functional imports end ------------------------- */

type Props = {
  pagetitle: string
}

/* -------------------------------------------------------------------------- */
/*                               Start Component                              */
/* -------------------------------------------------------------------------- */
export default function LoadingSkeleton(props: Props): ReactElement {
  /* -------------------------- Non state data start -------------------------- */
  const { pagetitle } = props
  /* --------------------------- Non state data end --------------------------- */

  /* -------------------------------------------------------------------------- */
  /*                              Render component                              */
  /* -------------------------------------------------------------------------- */
  return (
    <Page title={pagetitle}>
      <h1>
        <Skeleton />
      </h1>
      <Card variant="outlined">
        <CardContent>
          <Skeleton height={500} width={900} />
        </CardContent>
      </Card>
    </Page>
  )
}
